import postRequest from '../../../../postRequest';
/**
 * Post request for colour Matching.
 *
 * @param {number} languageId - 12
 * @param {string} newColourGroupName
 * @param {string} swatchColourIdsString
 */

export default function postMoveSwatchColour(
  languageId,
  newColourGroupName,
  swatchColourIdsString,
) {
  const endpoint = `/oc-data-management/v1/colourMatching/moveColours/${languageId}`;
  // const swatchOrTranslatedColour = languageId === 1 ? 'Swatch Colour' : 'Translated Colour';
  const body = {
    newColourGroupName,
    swatchColourIdsString,
  };
  return new Promise((resolve, reject) => {
    postRequest(endpoint, body)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  });
}
